import { createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
/**
 * @author chenjizhong
 * @fileoverview 首页/赛事荣誉榜 > 队员信息
 */
import { defineComponent } from "vue";
export default defineComponent({
  name: "PCMemberListItem",
  props: {
    itemInfo: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  setup(props) {
    return () => {
      const {
        itemInfo
      } = props;
      let avatar = itemInfo ? `${itemInfo.career}${itemInfo.sex}.png` : "高老庄男.png";
      let icon = itemInfo ? `${itemInfo.career}.png` : "高老庄.png";
      return _createVNode("div", {
        "class": "pc-information-item"
      }, [avatar && _createVNode("img", {
        "class": "avatar-img",
        "src": require(`@/assets/img/role/pc/${avatar}`)
      }, null), _createVNode("div", {
        "class": "member-info-box"
      }, [_createVNode("div", {
        "class": "info-item"
      }, [_createVNode("div", null, [_createTextVNode("\u540D\u79F0")]), _createVNode("div", null, [itemInfo === null || itemInfo === void 0 ? void 0 : itemInfo.name])]), _createVNode("div", {
        "class": "info-item"
      }, [_createVNode("div", null, [_createTextVNode("\u7B49\u7EA7")]), _createVNode("div", null, [itemInfo === null || itemInfo === void 0 ? void 0 : itemInfo.level])]), _createVNode("div", {
        "class": "info-item"
      }, [_createVNode("div", null, [_createTextVNode("\u95E8\u6D3E")]), _createVNode("div", null, [icon && _createVNode("img", {
        "class": "career-img",
        "src": require(`@/assets/img/career-icon/pc/${icon}`)
      }, null), itemInfo === null || itemInfo === void 0 ? void 0 : itemInfo.career])]), _createVNode("div", {
        "class": "info-item"
      }, [_createVNode("div", null, [_createTextVNode("\u6B66\u9053\u6BB5\u4F4D")]), _createVNode("div", null, [itemInfo !== null && itemInfo !== void 0 && itemInfo.rank_lev_name ? itemInfo.rank_lev_name : "无"])])])]);
    };
  }
});